import React from "react";

import "./Ratings.css"

const Ratings = () => {
  return (
    <div className="ratings-Details">
      <h2 className="ratings-title-Details">Ratings</h2>
      <div className="rating-levels">
        <div className="rating-level-wrapper">
          <div className="rating-level rating1"></div>
          <h4 className="rating-level-number">1</h4>
        </div>
        <div className="rating-level-wrapper">
          <div className="rating-level rating2"></div>
          <h4 className="rating-level-number">2</h4>
        </div>
        <div className="rating-level-wrapper">
          <div className="rating-level rating3"></div>
          <h4 className="rating-level-number">3</h4>
        </div>
        <div className="rating-level-wrapper">
          <div className="rating-level rating4"></div>
          <h4 className="rating-level-number">4</h4>
        </div>
        <div className="rating-level-wrapper">
          <div className="rating-level rating5"></div>
          <h4 className="rating-level-number">5</h4>
        </div>
        <div className="rating-level-wrapper">
          <div className="rating-level rating6"></div>
          <h4 className="rating-level-number">6</h4>
        </div>
        <div className="rating-level-wrapper">
          <div className="rating-level rating7"></div>
          <h4 className="rating-level-number">7</h4>
        </div>
        <div className="rating-level-wrapper">
          <div className="rating-level rating8"></div>
          <h4 className="rating-level-number">8</h4>
        </div>
        <div className="rating-level-wrapper">
          <div className="rating-level rating9"></div>
          <h4 className="rating-level-number">9</h4>
        </div>
        <div className="rating-level-wrapper">
          <div className="rating-level rating10"></div>
          <h4 className="rating-level-number">10</h4>
        </div>
      </div>
    </div>
  );
};

export default Ratings;
